<auto-main-navigation></auto-main-navigation>
<p-panel>
  <ng-template pTemplate="header">
    <h1>Media Ad Copy Bulk Update</h1>
  </ng-template>

  <p-tabView>
    <p-tabPanel header="Bulk Update Tool">
      <form [formGroup]="bulkUpdateForm" (ngSubmit)="onSubmit()">
        <div class="sharing-rule-input">
          <app-bulk-update-account-filter #accountFilter></app-bulk-update-account-filter>
          <p-divider></p-divider>
          <div class="input-column-wrapper">
            <label class="input-spacing"><b>Campaign Strategy</b></label>
            <div style="display:flex; gap:0.5rem; align-items:center;">
              <p-dropdown
                class="input-field-width"
                [options]="strategyOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Select a strategy"
                formControlName="strategy">
              </p-dropdown>
              <span [pTooltip]="getDisabledToolTip(accountFilter)" tooltipPosition="right">
                <button
                  pButton
                  type="button"
                  label="Preview"
                  icon="pi pi-search"
                  class="p-button-secondary"
                  (click)="onPreviewSingleAccount()"
                  [disabled]="previewCampaignsDisabled(accountFilter)">
                </button>
              </span>
            </div>
            <small class="p-d-block p-text-secondary">Choose a strategy, or select 'Expression Match' to enter an expression.</small>
            <div *ngIf="bulkUpdateForm.hasError('xorStrategyExpression') && (bulkUpdateForm.get('strategy')?.dirty || bulkUpdateForm.get('expression')?.dirty)" class="input-validation-wrapper">
              <small class="p-d-block p-error block">Provide exactly one of Strategy or Expression.</small>
            </div>
          </div>
          <div class="input-column-wrapper" *ngIf="bulkUpdateForm.get('strategy')?.value === expressionMatchLabel">
            <label class="input-spacing"><b>Campaign Expression</b></label>
            <div style="display:flex; gap:0.5rem; align-items:center;">
              <input
                type="text"
                pInputText
                class="input-field-width"
                formControlName="expression"
                id="campaign-name"
                placeholder="Enter Campaign Expression">
            </div>
            <div *ngIf="bulkUpdateForm.hasError('xorStrategyExpression') && (bulkUpdateForm.get('strategy')?.dirty || bulkUpdateForm.get('expression')?.dirty)" class="input-validation-wrapper">
              <small class="p-d-block p-error block">Provide exactly one of Strategy or Expression.</small>
            </div>
          </div>
        </div>
        <div class="sharing-rule-input">
          <div class="input-column-wrapper">
            <label class="input-spacing"><b>CSV File</b></label>
            <div class="file-upload-container">
              <input
                #fileInput
                type="file"
                id="csv-file"
                accept=".csv"
                (change)="onFileSelect($event)"
                hidden
              />
              <button
                pButton
                type="button"
                label="Upload CSV"
                icon="pi pi-upload"
                class="p-button-info"
                (click)="triggerFilePicker()"
              ></button>
              <small class="p-d-block" *ngIf="selectedFile as file">Selected: {{ file.name }}</small>
            </div>
          </div>
        </div>
        <div class="sharing-rule-input">
          <div class="input-column-wrapper">
            <label class="input-spacing"><b>Description</b></label>
            <textarea
              pInputTextarea
              class="input-field-width"
              formControlName="description"
              id="description"
              rows="3"
              placeholder="Enter a description">
            </textarea>
          </div>
        </div>
        <div class="confirm-button-field">
          <div class="cancel-confirm-buttons">
            <div class="cancel-preview-buttons-position">
              <button
                pButton
                type="submit"
                label="Submit"
                icon="pi pi-check"
                class="p-button-success"
                [disabled]="bulkUpdateForm.invalid || !selectedFile || isUploading || invalidAccountFilter(accountFilter)">
              </button>
              <p-progressSpinner *ngIf="isUploading" class="p-button-success" [style]="{height: '2.5rem'}" strokeWidth="8"></p-progressSpinner>
            </div>
            <div>
              <div *ngIf="bulkUpdateForm.invalid || !selectedFile || invalidAccountFilter(accountFilter)" class="input-validation-wrapper">
                <small class="p-d-block p-error block">All fields must be filled out to submit.</small>
              </div>
            </div>
          </div>
        </div>
      </form>
    </p-tabPanel>
    <p-tabPanel header="Executions">
      <auto-bulk-update-execution></auto-bulk-update-execution>
    </p-tabPanel>
  </p-tabView>
</p-panel>
<auto-footer></auto-footer>
